import React from "react";
import ReactGA from "react-ga4";
import {
  Grid,
  TextField,
  InputAdornment,
  Typography,
  SpeedDial,
  SpeedDialAction,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import request from "../../utilities/requests";
import SearchResults from "./components/SearchResults";
import AddUserDialog from "../../components/AddUserDialog/AddUserDialog";
import UploadUserDialog from "./components/UploadUserDialog";

const Users = ({ user }) => {
  const [users, setUsers] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [uploadDialogOpen, setUploadDialogOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/users",
      title: "Users",
    });
  }, []);

  const handleUploadOpen = () => setUploadDialogOpen(true);
  const handleUploadClose = () => setUploadDialogOpen(false);

  const searchUsers = async (val) => {
    setLoading(true);
    setUsers([]);
    const body = { value: val };
    const result = await request("users/search", "post", body);
    if (result.success) {
      setUsers(result.users);
    }
    setLoading(false);
  };

  const handleChange = (event) => {
    setSearch(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      searchUsers(search);
    }
  };

  const handleRefresh = () => {
    searchUsers(search);
  };

  return (
    <>
      <Grid
        container
        direction="column"
        // justifyContent="center"
        alignItems="center"
        spacing={3}
        style={{ padding: 20 }}
      >
        <Grid item>
          <Typography variant="h6">User Search</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            variant="outlined"
            // fullWidth
            size="small"
            type="search"
            InputProps={{
              style: { borderRadius: 20 },
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => searchUsers(search)}
                  />
                </InputAdornment>
              ),
            }}
            value={search}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </Grid>

        <Grid item>
          {loading ? (
            <CircularProgress sx={{mt: 2}}/>
          ) : (
            <SearchResults users={users} refresh={handleRefresh} />
          )}
        </Grid>
      </Grid>

      <SpeedDial
        ariaLabel="Upload users"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
        icon={<MoreVertIcon />}
      >
        <SpeedDialAction
          icon={<UploadIcon />}
          tooltipTitle="Upload Users"
          onClick={handleUploadOpen}
        />
      </SpeedDial>

      <UploadUserDialog open={uploadDialogOpen} onClose={handleUploadClose} />
    </>
  );
};

export default Users;
